import map from 'lodash/map';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { SuggestedLabelsResponse, QueryParams } from './types.tsx';

const toPathQuery = (value: string, key: string) => {
	if (value === '') {
		return `${encodeURIComponent(key)}=`;
	}

	return value ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : undefined;
};

const serialize = (obj: QueryParams) =>
	// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
	map(obj, (value, key) => toPathQuery(value, key))
		.filter((val) => val !== undefined)
		.join('&');

export const constructEndpoint = (params: QueryParams) =>
	`/rest/api/1.0/labels/suggest?${serialize(params)}`;

export const get = (params: QueryParams): Promise<SuggestedLabelsResponse> =>
	fetchJson(constructEndpoint(params));
